import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import Cookie from 'js-cookie'
import { notify } from '../../utils/notifications'
import { KEY_STAKING_NOTI_DATE_COOKIE } from '../../utils/states'
import { getHourDate } from '../../utils/utils'

export default function StakingNoticeDialog() {
  const [open, setOpen] = useState(true)
  const [teramCheck, setTeramCheck] = useState(false)

  const today = new Date()
  const todayDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-jacarta-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 w-screen overflow-y-auto bg-jacarta-200 bg-opacity-60">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="w-full h-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-jacarta-800">
                  Staking Beta Open!
                </Dialog.Title>
                <div className="relative mt-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-jacarta-100" />
                  </div>
                </div>
                <div className="mt-12 h-[180px] text-[14px]">
                  <div className="text-jacarta-800">
                    Now you can earn extra rewards by staking!
                    <br />
                    Stake $WKM/$WKG to get more earnings.
                  </div>

                  <div className="mt-6 text-[11px] text-jacarta-600">
                    This service is subject to the WalkMining{' '}
                    <a
                      className="text-blue"
                      href="https://www.walkmining.com/terms-of-service"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Use
                    </a>
                    .<br />
                    Reward distribution may be refused if the Terms of Use are violated by abusing, using it from
                    restricted countries, etc.
                  </div>
                </div>
                <div className="mb-2">
                  <div className="flex items-center text-[12px] text-jacarta-600 mb-3">
                    <input
                      id="staking-trem-check"
                      name="staking-trem-check"
                      type="checkbox"
                      value={teramCheck}
                      onChange={(e) => {
                        setTeramCheck(e.target.checked)
                      }}
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <div className="ml-2">
                      <label htmlFor="staking-trem-check" className="text-sm font-medium text-gray-900">
                        I read the above and agree with it.
                      </label>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="flex justify-center items-center w-full h-12 hover:bg-jacarta-600 text-[16px] rounded-full bg-[#131740] text-white"
                    onClick={() => {
                      if (teramCheck) {
                        Cookie.set(KEY_STAKING_NOTI_DATE_COOKIE, todayDate, { expires: getHourDate() })
                        setOpen(false)
                      } else {
                        notify({
                          message: 'Consent is required.',
                          type: 'error',
                        })
                      }
                    }}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="w-full mt-3 text-sm text-jacarta-600 dark:text-jacarta-600"
                    onClick={() => {
                      window.location.replace('/')
                    }}
                  >
                    Go back
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
